import { z } from "zod";
import { AssetScope } from "../assets";

//
// Abstract
//

export const ImageImportModelType = z.enum(["Url", "FigmaRender"]);
export type ImageImportModelType = z.infer<typeof ImageImportModelType>;

const ImageImportModelBase = z.object({
  scope: AssetScope,
});

//
// Url
//

export const UrlImageImportModel = ImageImportModelBase.extend({
  type: z.literal(ImageImportModelType.enum.Url),
  url: z.string(),
  originKey: z.string(),
  extension: z.string(),
});

export type UrlImageImportModel = z.infer<typeof UrlImageImportModel>;

//
// Figma Render
//

export const FigmaRenderFormat = z.enum(["Svg", "Png", "Pdf"]);

const FigmaRenderBase = ImageImportModelBase.extend({
  type: z.literal(ImageImportModelType.enum.FigmaRender),
  fileId: z.string(),
  fileVersionId: z.string().optional(),
  nodeId: z.string(),
  originKey: z.string(),
});

export const FigmaPngRenderImportModel = FigmaRenderBase.extend({
  format: z.literal(FigmaRenderFormat.enum.Png),
  scale: z.number(),
});

export const FigmaSvgRenderImportModel = FigmaRenderBase.extend({
  format: z.literal(FigmaRenderFormat.enum.Svg),
});

export const FigmaRenderImportModel = z.discriminatedUnion("format", [
  FigmaPngRenderImportModel,
  FigmaSvgRenderImportModel,
]);

//
// Union
//

// Unfortunately discriminated union doesn't support inserting another discriminated union
export const ImageImportModel = z.union([UrlImageImportModel, FigmaRenderImportModel]);

//
// Types
//

export type FigmaRenderFormat = z.infer<typeof FigmaRenderFormat>;
export type FigmaRenderBase = z.infer<typeof FigmaRenderBase>;
export type FigmaPngRenderImportModel = z.infer<typeof FigmaPngRenderImportModel>;
export type FigmaSvgRenderImportModel = z.infer<typeof FigmaSvgRenderImportModel>;
export type FigmaRenderImportModel = z.infer<typeof FigmaRenderImportModel>;
export type ImageImportModel = z.infer<typeof ImageImportModel>;

//
// Utils
//

export function getFigmaRenderFormatFileExtension(format: FigmaRenderFormat): string {
  switch (format) {
    case "Pdf":
      return "pdf";
    case "Png":
      return "png";
    case "Svg":
      return "svg";
  }
}
